import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

import DietSettingsQuery from './DietSettingsQuery';

const DietSettingsConnectorApollo = ({ children }) => {
  const { data, loading, error } = useQuery(DietSettingsQuery, {
    fetchPolicy: 'no-cache',
  });

  const result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.dietSettings = data.me;
  }

  return children(result);
};

DietSettingsConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default DietSettingsConnectorApollo;
